import React, { useEffect, useState } from "react";
import { MyResponsiveBar } from "../Barchart/barChart";
import { Grid, CardContent, makeStyles } from "@material-ui/core";
import { Card, CardHeader, CardFooter } from "../../../shared/Card/Index";
import AccessTime from "@material-ui/icons/AccessTime";
import { updateObject } from "../../../shared/utility";
import { connect } from "react-redux";
import * as alertTypes from "../../../shared/language.json";
import { OpenAlertsPie } from "../PieAlertsOpen/PieAlertOpen";
import axiosConfig from "../../../axiosConfig";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./StatisticsGridHome&Map.css";
import * as alarmSeverityType from "./../../../shared/alarmSeverity.json";
import styles from "../../../shared/dashboardStyle";

const useStyles = makeStyles(styles);

export const StatisticsGridForHomeAndMap = ({
  className,
  pointsStore,
  ...rest
}) => {
  const [openData, setOpenData] = useState([
    {
      id: alarmSeverityType.ALARMSSEVERITY.LOWRISK,
      label: alertTypes.ALERTSTYPE.LOWRISK,
      value: 0,
      color: "#01579B",
    },
    {
      id: alarmSeverityType.ALARMSSEVERITY.MIDDLERISK,
      label: alertTypes.ALERTSTYPE.MIDDLERISK,
      value: 0,
      color: "#0288D1",
    },
    {
      id: alarmSeverityType.ALARMSSEVERITY.HIGHRISK,
      label: alertTypes.ALERTSTYPE.HIGHRISK,
      value: 0,
      color: "#03A9F4",
    },
  ]);
  const [barData, setBarData] = useState([
    {
      label: alertTypes.ALERTSBARDATA.DIASTOLICPRESSURE,
      description: alertTypes.ALERTSBARDATA.DIASTOLICPRESSURE,
      cntHighRisk: 0,
      cntModerateRisk: 0,
      cntLowRisk: 0,
    },
    {
      label: alertTypes.ALERTSBARDATA.SYSTOLICPRESSURE,
      description: alertTypes.ALERTSBARDATA.SYSTOLICPRESSURE,
      cntHighRisk: 0,
      cntModerateRisk: 0,
      cntLowRisk: 0,
    },
    {
      label: alertTypes.ALERTSBARDATA.BODYTEMPERATURE,
      description: alertTypes.ALERTSBARDATA.BODYTEMPERATURE,
      cntHighRisk: 0,
      cntModerateRisk: 0,
      cntLowRisk: 0,
    },
    {
      label: alertTypes.ALERTSBARDATA.SPO2,
      description: alertTypes.ALERTSBARDATA.SPO2,
      cntHighRisk: 0,
      cntModerateRisk: 0,
      cntLowRisk: 0,
    },
    {
      label: alertTypes.ALERTSBARDATA.HEARTBEATS,
      description: alertTypes.ALERTSBARDATA.HEARTBEATS,
      cntHighRisk: 0,
      cntModerateRisk: 0,
      cntLowRisk: 0,
    },
  ]);
  const [statusData, setStatusData] = useState([
    {
      color: "#03A9F4",
      id: 1,
      label: alertTypes.ALERTSTATUS.OPEN,
      value: 0,
    },
    {
      color: "#0288D1",
      id: 2,
      label: alertTypes.ALERTSTATUS.PENDING,
      value: 0,
    },
  ]);
  const [loading, setLoading] = useState(true);
  const [home, setHome] = useState(true);

  const classes = useStyles();

  const alarmSeverityDescriptionHandler = (alarmSeverity, data) => {
    if (alarmSeverity === alarmSeverityType.ALARMSSEVERITY.HIGHRISK) {
      data[0] = data[0] + 1;
    } else if (alarmSeverity === alarmSeverityType.ALARMSSEVERITY.MIDDLERISK) {
      data[1] = data[1] + 1;
    } else if (alarmSeverity === alarmSeverityType.ALARMSSEVERITY.LOWRISK) {
      data[2] = data[2] + 1;
    }
  };

  useEffect(() => {
    if (pointsStore) {
      let alertStatusData = {
        1: { alarmCount: 0, label: alertTypes.ALERTSTATUS.OPEN },
        2: { alarmCount: 0, label: alertTypes.ALERTSTATUS.PENDING },
        3: { alarmCount: 0, label: alertTypes.ALERTSTATUS.CLOSED },
      };

      let openAlarmData = {
        [alarmSeverityType.ALARMSSEVERITY.HIGHRISK]: {
          alarmCount: 0,
          label: alarmSeverityType.ALARMSSEVERITY.HIGHRISK,
        },
        [alarmSeverityType.ALARMSSEVERITY.MIDDLERISK]: {
          alarmCount: 0,
          label: alarmSeverityType.ALARMSSEVERITY.MIDDLERISK,
        },
        [alarmSeverityType.ALARMSSEVERITY.LOWRISK]: {
          alarmCount: 0,
          label: alarmSeverityType.ALARMSSEVERITY.LOWRISK,
        },
      };

      let alertBarData = {
        [alertTypes.ALERTSBARDATA.SYSTOLICPRESSURE]: [0, 0, 0],
        [alertTypes.ALERTSBARDATA.DIASTOLICPRESSURE]: [0, 0, 0],
        [alertTypes.ALERTSBARDATA.BODYTEMPERATURE]: [0, 0, 0],
        [alertTypes.ALERTSBARDATA.SPO2]: [0, 0, 0],
        [alertTypes.ALERTSBARDATA.HEARTBEATS]: [0, 0, 0],
      };

      pointsStore.map((point) => {
        point.alarms.map((alarm) => {
              alertStatusData[alarm.statusId].alarmCount++;
              openAlarmData[alarm.alarmSeverity].alarmCount++;
            if (alertBarData[alarm.alarmType]) {
              alarmSeverityDescriptionHandler(
                alarm.alarmSeverity,
                alertBarData[alarm.alarmType]
              );
            }
        });
      });

      setStatusData((data) =>
        data.map((alert) => {
          if (alert.label === alertTypes.ALERTSTATUS.OPEN) {
            return updateObject(alert, {
              value: alertStatusData["1"].alarmCount,
            });
          } else if (alert.label === alertTypes.ALERTSTATUS.PENDING) {
            return updateObject(alert, {
              value: alertStatusData["2"].alarmCount,
            });
          }
        })
      );

      setOpenData((data) =>
        data.map((alarm) => {
          return updateObject(alarm, {
            value: openAlarmData[alarm.id].alarmCount,
          });
        })
      );

      setBarData((data) =>
        data.map((alarm) => {
          return updateObject(alarm, {
            cntHighRisk: alertBarData[alarm.description][0],
            cntModerateRisk: alertBarData[alarm.description][1],
            cntLowRisk: alertBarData[alarm.description][2],
          });
        })
      );
    }
    setLoading(false);
  }, [pointsStore]);

  if (loading === false) {
    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>
                  Ειδοποιήσεις Ανοιχτές/Σε εξέλιξη ανά Τύπο
                </h4>
              </CardHeader>
              <CardContent style={{ height: 300, position: "relative" }}>
                <MyResponsiveBar origin="Type" data={barData} />
              </CardContent>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> Στατιστικά
                </div>
              </CardFooter>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>
                  Ειδοποιήσεις Ανοιχτές/Σε εξέλιξη
                </h4>
              </CardHeader>
              <OpenAlertsPie statusData={statusData} home={home} />
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> Στατιστικά
                </div>
              </CardFooter>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>
                  Ειδοποιήσεις Ανοιχτές/Σε εξέλιξη Ανά Δείκτη Κινδύνου
                </h4>
              </CardHeader>
              <OpenAlertsPie riskData={openData} />
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> Στατιστικά
                </div>
              </CardFooter>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return <CircularProgress></CircularProgress>;
  }
};

const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

export default connect(mapStateToProps)(StatisticsGridForHomeAndMap);
